import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const termsSections = [
  {
    title: "Using our store",
    body: [
      `These terms apply when you visit the ${siteConfig.brandName} website or place an order with us. By using the store, you agree to these terms and the policies linked from it.`,
      "You must be able to enter a binding contract and provide accurate contact, payment and delivery information. Products restricted by age may be purchased and received only by a person who meets the applicable legal age requirement.",
    ],
  },
  {
    title: "Policies forming part of these terms",
    body: [
      "The policy center contains the operational policies that apply to matters such as payment, delivery, returns, food safety, privacy and acceptable use. If a specific promotion has additional terms, those terms apply to that promotion. If documents conflict, the more specific term governs the relevant issue unless mandatory law requires otherwise.",
    ],
  },
  {
    title: "Products and availability",
    body: [
      "We aim to describe products, origins, allergens, weights and images accurately. Screen colours, artisan production and natural ingredients mean the item delivered may vary slightly from its photograph or stated approximate weight.",
      "All products are subject to availability. If an item becomes unavailable after you order, we will contact you to arrange a suitable substitution, credit or refund; we will not substitute an item without your agreement where allergens or important product characteristics may differ.",
    ],
  },
  {
    title: "Orders and acceptance",
    body: [
      "Submitting checkout is an offer to purchase. An automatic acknowledgement confirms that we received the order, not that we accepted it. Acceptance occurs when we confirm fulfilment or dispatch, and we may decline or limit an order for stock, payment, delivery, pricing-error or suspected misuse reasons.",
      "Please review your order carefully before payment and contact us promptly if anything is incorrect.",
    ],
  },
  {
    title: "Prices and payment",
    body: [
      `Prices are shown in ${siteConfig.currency.code} unless stated otherwise. Delivery charges, discounts and the final total are displayed before you place an order.`,
      "Payment must be authorised through an available checkout method. If a clear pricing or promotional error affects an order, we may cancel the affected item and refund it, or ask whether you wish to proceed at the correct price.",
    ],
  },
  {
    title: "Promotions",
    body: [
      "A promotion is subject to the eligibility, dates, exclusions and limits displayed with it. A code must normally be applied before checkout. We may reject automated, deceptive or abusive redemption, but we will not remove a valid discount from an accepted order without a lawful basis.",
    ],
  },
  {
    title: "Delivery, title and risk",
    body: [
      "Delivery estimates are provided in good faith and can change because of weather, traffic, access or events outside reasonable control. Responsibility for the order passes to you when it is delivered to the address or authorised safe place you supplied.",
      "You are responsible for refrigerating temperature-sensitive products promptly. Please read our Shipping & delivery policy for fees, coverage and receiving instructions.",
    ],
  },
  {
    title: "Cancellations, returns and refunds",
    body: [
      "Fresh and made-to-order products cannot always be cancelled or returned once preparation has started. Eligibility for a replacement, return, credit or refund is explained in our Returns & refunds policy. Nothing in these terms excludes rights that cannot lawfully be excluded.",
    ],
  },
  {
    title: "Acceptable use and intellectual property",
    body: [
      "You may use the website for lawful personal shopping. You must not disrupt the service, attempt unauthorised access, introduce malicious code, scrape the store at unreasonable volume or use content in a misleading or infringing way.",
      `The site design, original text, graphics and brand assets belong to ${siteConfig.brandName} or their respective licensors. You may not reproduce or commercially exploit them without prior written permission.`,
    ],
  },
  {
    title: "Accounts and security",
    body: [
      "Where account features are available, you are responsible for accurate details and for protecting sign-in links, passwords and devices. Tell us promptly about suspected unauthorised access or an order you do not recognise. We may apply proportionate restrictions while investigating fraud, misuse or a security risk.",
    ],
  },
  {
    title: "Liability",
    body: [
      "To the fullest extent allowed by law, we are not responsible for indirect or unforeseeable loss arising from use of the store. We do not exclude liability where doing so would be unlawful, including liability for fraud or for personal injury caused by negligence.",
      "Product information is not medical advice. Customers with allergies or dietary requirements should review the current packaging and contact us before consuming a product if anything is unclear.",
    ],
  },
  {
    title: "Events outside reasonable control",
    body: [
      "Neither party is responsible for delay or failure caused by an event it could not reasonably control, such as severe weather, transport disruption, government action, widespread network failure or an import restriction. This does not excuse payment already due or prevent a refund where goods cannot be supplied and the law requires one.",
    ],
  },
  {
    title: "Changes, severability and waiver",
    body: [
      "The terms in force when an order is accepted apply to that order unless a change is required by law or agreed with you. If a provision is unenforceable, the remaining provisions continue to apply. A delay in enforcing a right does not waive it.",
    ],
  },
  {
    title: "Governing law, complaints and contact",
    body: [
      `These terms are governed by the laws of Hong Kong SAR, and disputes are subject to the jurisdiction of its courts unless mandatory consumer law provides otherwise. Start a complaint by emailing ${siteConfig.contact.email}; our Complaints & dispute resolution policy explains the review process.`,
    ],
  },
];

function Terms() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Terms & conditions"
      intro={`The practical terms for browsing, ordering and shopping with ${siteConfig.brandName}.`}
      sections={termsSections}
    />
  );
}

export default Terms;
